import React from "react"
import styled from "styled-components"
import { COLORS, IMAGES } from "../../constants"
import { P, SectionTitle, Effect } from "../../components"
import { darken } from "polished"
import { LazyImage } from "cn-react-helpers"

export function Header({ CITY }){
  const Top = styled(P)`
    color: ${COLORS.WHITE};
    text-align: center;
    margin-bottom: 60px;
  `

  const Container = styled.section`
    position: relative;
    overflow: hidden;
    padding: 20px 20px 100px 20px;
    background-color: ${CITY.COLOR};
    background-image: url("${IMAGES.MOBBY_EFFECT}");
    background-repeat: no-repeat;
    background-attachment: scroll;
    background-position-x: 80vw;
    background-size: 700px;
    background-position-y: center;

    @media(max-width: 800px){
      padding: 20px 20px 60px 20px;
      background-position-y: -250px;
      background-size: 500px;
      background-position-x: center;
    }
  `

  const Content = styled.div`
    width: 100%;
    max-width: 900px;
    display: flex;
    position: relative;
    z-index: 10;
    margin: 0 auto;

    @media(max-width: 800px){
      flex-direction: column-reverse;
    }
  `

  const Mobile = styled.div`
    height: auto;
    width: 100%;
    max-width: 340px;
    margin-right: 60px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-top: solid rgba(0, 0, 0, 0.8) 40px;
    border-bottom: solid rgba(0, 0, 0, 0.8) 70px;
    border-left: solid rgba(0, 0, 0, 0.8) 8px;
    border-right: solid rgba(0, 0, 0, 0.8) 8px;
    border-radius: 30px;
    overflow: hidden;

    img{
      width: 100%;
      height: auto;
    }

    @media(max-width: 800px){
      margin: 0 auto;
      max-width: 260px;
    }
  `

  const Description = styled.div`
    width: 100%;
    padding-top: 50px;

    @media(max-width: 800px){
      margin-bottom: 50px;
      padding-top: 0px;
    }
  `

  const Logo = styled(LazyImage)`
    width: 100%;
    max-width: 140px;
    margin-bottom: 30px;
    display: block;
    border-radius: 23px;
    background: white;
    border: solid white 2px;
    box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.4);

    @media(max-width: 800px){
      max-width: 160px;
      margin:0 auto 30px auto;
    }
  `

  const Title = styled(SectionTitle)`
    margin-bottom: 30px;
    text-align: left;
    color: ${ COLORS.WHITE };
    background: inherit;

    @media(max-width: 800px){
      text-align: center;
    }
  `

  const Text = styled(P)`
    color: ${COLORS.WHITE};

    @media(max-width: 800px){
      margin: 0 auto;
      max-width: 400px;
      text-align: center;
    }
  `

  const Citation = styled.div`
    padding: 150px 20px 150px 20px;
    background-color: ${darken(0.06, CITY.COLOR)};
    width: 100%;
    position: relative;
    overflow: hidden;

    @media(max-width: 800px){
      padding: 50px 20px 50px 20px;
    }
  `

  const CitationText = styled.h1`
    font-weight: 300px;
    text-align: center;
    font-weight: 300;
    font-size: 3em;
    color: ${COLORS.WHITE};
    position: relative;
    z-index: 10;

    @media(max-width: 800px){
      font-size: 1.5em;
    }
  `

  return (
    <>
      <Container>
        <Top> {CITY.TOP} </Top>
        <Content>
          <Mobile>
            <LazyImage
              loader={IMAGES.MOBILE_LOADER}
              source={CITY.MOCKUP}
              alt="Mockup" />
          </Mobile>

          <Description>
            <Logo
              loader={IMAGES.CITY_LOGO_LOADER}
              source={CITY.ICON} />
            <Title> {CITY.TITLE} </Title>
            <Text> {CITY.DESCRIPTION} </Text>
          </Description>
        </Content>
      </Container>

      <Citation>
        <Effect />
        <CitationText>
          {CITY.SLOGAN}
        </CitationText>
      </Citation>

    </>
  )
}

